module.exports = __webpack_public_path__ + "static/staticAlternativesYes-66b330a97798954f805aac39672e22c2.png";